import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/sale.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import { saveAs } from "file-saver";
import copyLink from "../assets/images/DeathModuleNew/create-link-svgrepo-com.svg";
import fileIcon from "../assets/images/DeathModuleNew/Icons.png";
import SearchIcon from "../assets/images/DeathModuleNew/Search.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import "./styledComponents/styles/checklist.css";
import { Modal, Table } from "antd";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
// import Table from "./styledComponents/Table/Table";
import List from "./styledComponents/Table/List";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import swal from "sweetalert";
import MODULE_API from "../apis/module.api";
import ViewModal from "./styledComponents/Modal/ViewModal";

import axios from "axios";

export const ContactList = (props) => {
  const NoteComponent = ({ record }) => {
    const [isTruncated, setIsTruncated] = useState(true);

    const toggleTruncate = () => {
      setIsTruncated(!isTruncated);
    };

    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        {record ? (
          <div>
            {isTruncated ? (
              <span>
                {record.length > 15 ? `${record.substring(0, 15)}...` : record}
                {record.length > 15 && (
                  <Style.Title
                    style={{ cursor: "pointer", fontWeight: "700" }}
                    onClick={toggleTruncate}>
                    Read more
                  </Style.Title>
                )}
              </span>
            ) : (
              <span>
                {record}
                <Style.Title
                  style={{ cursor: "pointer", fontWeight: "700" }}
                  onClick={toggleTruncate}>
                  Read less
                </Style.Title>
              </span>
            )}
          </div>
        ) : (
          "N/A"
        )}
      </div>
    );
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (record) => (record ? record : "N/A"),
    },
  ];

  const groupCols = [
    {
      title: "Group Name",
      dataIndex: "name",
      render: (fileName, record) => {
        return record.name ? (
          <div style={{ textAlign: "center", display: "flex" }}>
            {record.name && (
              <span style={{ color: "black", marginRight: "1rem" }}>
                {record.name}
              </span>
            )}
            <div>( {record.count} )</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },
  ];
  const cols = [
    {
      title: "First Name",
      dataIndex: "firstName",
      sorter: (a, b) =>
        a.firstName > b.firstName ? 1 : a.firstName === b.firstName ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      sorter: (a, b) => a["lastName"] > b["lastName"],
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Mobile Phone",
      dataIndex: "phone",
      render: (record) => (record ? formatPhoneNumber(record) : "N/A"),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Trusted Team",
      dataIndex: "isTrusted",
      sorter: (a, b) => a["isTrusted"] > b["isTrusted"],
      render: (record) => (record === true ? "YES" : "NO"),
    },
    {
      title: "Trusted Status",
      dataIndex: "status",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Type of Relation",
      dataIndex: "typeOfRelation",
      sorter: (a, b) => a["typeOfRelation"] > b["typeOfRelation"],
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Part of Core Team",
      dataIndex: "partOfCoreTeam",
      sorter: (a, b) => a["partOfCoreTeam"] > b["partOfCoreTeam"],
      render: (record) => (record === true ? "YES" : "NO"),
    },

    {
      title: "Notes",
      dataIndex: "note",
      render: (note) => <NoteComponent record={note} />,
    },

    {
      title: "Invite Link",
      dataIndex: "invite",
      render: (fileName, record) => {
        let link = record.invite && record.invite;
        const copyInviteLink = () => {
          navigator.clipboard.writeText(
            `${"https://dashboard.assetplanet.com/acceptInvitation?inviteCode="}${link}`
          );
          swal("Success", "Invite Link Copied", "success");
        };
        return record.invite ? (
          <div
            style={{ display: "flex", alignItems: "center", width: "100px" }}>
            {" "}
            <Style.CopyButton onClick={copyInviteLink}>
              Copy Link
            </Style.CopyButton>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center" }}>
          Action{" "}
          <img
            style={{
              cursor: "pointer",
              marginLeft: "8px",
              width: "25px",
              height: "25px",
              marginTop: "10px",
            }}
            src={helpIcon}
            alt="helpicon"
            onClick={() => {
              showActionModal();
            }}></img>
        </div>
      ),
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id, contactList);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];
  const contactFields = [
    {
      title: "First Name",
      type: "input",
      index: "FirstName",
    },
    {
      title: "Last Name",
      type: "input",
      index: "LastName",
    },
    {
      title: "Type Of Relation",
      type: "select",
      options: [
        "Accounting - CPA",
        "Accounting - Bookkeeper",
        "Child",
        "Consultant",
        "Family",
        "Financial Services - Advisor",
        "Financial Services - Wealth Planner",
        "Financial Services - Insurance Agent Property",
        "Financial Services - Insurance Agent Life",
        "Friend",
        "Health - Doctor",
        "Health - Dentist",
        "Health - Veterinarian",
        "Health - Pharmacist",
        "Lawyer",
        "Professional",
        "Spouse/Partner",
        "Others",
      ],
      index: "TypeOfRelation",
    },
    {
      title: "Mobile Phone",
      type: "phoneNumber",
      index: "Phone",
    },
    {
      title: "Alternate Phone",
      type: "phoneNumberA",
      index: "AlternatePhone",
    },
    {
      title: "Email",
      type: "emails",
      index: "Email",
    },
    {
      title: "Address",
      type: "input",
      index: "Address",
    },
    {
      title: "City",
      type: "input",
      index: "City",
    },
    {
      title: "State",
      type: "input",
      index: "State",
    },

    {
      title: "Zip Code",
      type: "input",
      index: "ZipCode",
    },

    {
      title: "Company",
      type: "input",
      index: "Company",
    },

    {
      title: "*Trusted Individual*",
      type: "radio",
      index: "Individual",
    },
    {
      title: "Second Password Granted",
      type: "radio",
      index: "secondPasswordGranted",
    },
    {
      title: "Part of Core Team",
      type: "radio",
      index: "partOfCoreTeam",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
    {
      title: "Upload Image",
      type: "Image",
      index: "uploadImage",
    },
    // {
    //   title: "Video",
    //   type: "video",
    //   index: "Video",
    // },
    // {
    //   title: "Audio",
    //   type: "audio",
    //   index: "Audio",
    // },
  ];

  const UpdateContactFields = [
    {
      title: "First Name",
      type: "input",
      index: "firstName",
    },
    {
      title: "Last Name",
      type: "input",
      index: "lastName",
    },
    {
      title: "Mobile Phone",
      type: "phoneNumber1",
      index: "phone",
    },

    {
      title: "Alternate Phone",
      type: "phoneNumberA",
      index: "alternatePhone",
    },

    {
      title: "Address",
      type: "input",
      index: "address",
    },
    {
      title: "City",
      type: "input",
      index: "city",
    },
    {
      title: "State",
      type: "input",
      index: "state",
    },

    {
      title: "Zip Code",
      type: "input",
      index: "zipCode",
    },
    {
      title: "Email",
      type: "email1",
      index: "email",
    },
    {
      title: "Company",
      type: "input",
      index: "company",
    },

    {
      title: "Type Of Relation",
      type: "select",
      options: [
        "Accounting - CPA",
        "Accounting - Bookkeeper",
        "Child",
        "Consultant",
        "Family",
        "Financial Services - Advisor",
        "Financial Services - Wealth Planner",
        "Financial Services - Insurance Agent Property",
        "Financial Services - Insurance Agent Life",
        "Friend",
        "Health - Doctor",
        "Health - Dentist",
        "Health - Veterinarian",
        "Health - Pharmacist",
        "Lawyer",
        "Professional",
        "Spouse/Partner",
        "Others",
      ],
      index: "typeOfRelation",
    },
    {
      title: "*Trusted Individual*",
      type: "radio",
      index: "isTrusted",
    },
    {
      title: "Second Password Granted",
      type: "radio",
      index: "secondPasswordGranted",
    },
    {
      title: "Part of Core Team",
      type: "radio",
      index: "partOfCoreTeam",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
    {
      title: "Upload Image",
      type: "Image",
      index: "uploadImage",
    },
    // {
    //   title: "Video",
    //   type: "video",
    //   index: "videoUrl",
    // },
    // {
    //   title: "Audio",
    //   type: "audio",
    //   index: "audioUrl",
    // },
  ];
  const [contactList, setContactList] = useState([]);
  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [tooltipModal, setTooltipModal] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [MyId, setMyId] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [showConatctsModal, setShowConatctsModal] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [clientContacts, setClientContacts] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allGroups, setAllGroups] = useState([]);

  const handleSelect = (record, selected) => {
    console.log("selected", record, selected);
    if (selected) {
      setSelectedRowKeys((prevSelectedRowKeys) => [
        ...prevSelectedRowKeys,
        record.key,
      ]);
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, record]);
    } else {
      setSelectedRowKeys((prevSelectedRowKeys) =>
        prevSelectedRowKeys.filter((key) => key !== record.key)
      );
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((row) => row.key !== record.key)
      );
    }
  };

  const handleSelectAll = (selected, selectedRows) => {
    if (selected) {
      setSelectedRowKeys(selectedRows.map((row) => row.key));
      setSelectedRows(selectedRows);
    } else {
      setSelectedRowKeys([]);
      setSelectedRows([]);
    }
  };

  // console.log("selectedRowKeys",selectedRowKeys, selectedRows)

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    onSelectAll: handleSelectAll,
  };

  const [dropDownContactList, setDropDownContactList] = useState(false);

  function formatPhoneNumber(phoneWithCountryCode) {
    // Remove any non-numeric characters from the phone number
    const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, "");
    if (
      numericPhoneNumber.startsWith("1") &&
      numericPhoneNumber.length === 11
    ) {
      // Format as a USA number (e.g., +1 408-123-4567)
      return `+1 ${numericPhoneNumber.slice(1, 4)}-${numericPhoneNumber.slice(
        4,
        7
      )}-${numericPhoneNumber.slice(7)}`;
    } else if (
      numericPhoneNumber.startsWith("44") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a UK number (e.g., +44 20 1234 5678)
      return `+44 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        8
      )} ${numericPhoneNumber.slice(8)}`;
    } else if (
      numericPhoneNumber.startsWith("49") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Germany number (e.g., +49 30 12345678)
      return `+49 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        12
      )}`;
    } else if (
      numericPhoneNumber.startsWith("92") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Pakistan number (e.g., +92 300 1234567)
      return `+92 ${numericPhoneNumber.slice(2, 5)} ${numericPhoneNumber.slice(
        5,
        12
      )}`;
    } else {
      return phoneWithCountryCode;
    }
  }
  // function formatPhoneNumber(phoneNumber) {
  //   // Remove any non-numeric characters
  //   const numericPhoneNumber = phoneNumber.split(' ')[1].replace(/\D/g, '');
  //   const countryCode = phoneNumber.split(' ')[0];
  //   // Add the country code and hyphens
  //   return `${countryCode} ${numericPhoneNumber.substring(1, 4)}-${numericPhoneNumber.substring(4, 7)}-${numericPhoneNumber.substring(7)}`;
  // }
  // function formatPhoneNumber(phoneWithCountryCode) {
  //   const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, '');
  //   if (numericPhoneNumber.length >= 7) {
  //     let formattedNumber = `+${numericPhoneNumber[0]}`;
  //     let numericIndex = 1;
  //     for (let i = 1; i < numericPhoneNumber.length; i++) {
  //       if (i === 2 || i === 4 || i === 6) {
  //         formattedNumber += '-';
  //       }
  //       formattedNumber += numericPhoneNumber[numericIndex];
  //       numericIndex++;
  //     }
  //     return formattedNumber;
  //   } else {
  //     return 'Invalid phone number';
  //   }
  // }

  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleSearch = async (e) => {
    console.log("search value", e.target.value);
    let SearchValue = e.target.value;
    try {
      setLoading(true);

      setTimeout(async () => {
        const res = await DEATH_API.searchContactList(SearchValue);
        console.log("res", res);
        if (res.data && res.data.length > 0) {
          console.log("res..... search", res.data[0].contacts);
          res.data[0].contacts.map(
            (item, idx) => (
              (item["firstName"] = item.firstName),
              (item["lastName"] = item.lastName),
              (item["email"] = item.email),
              (item["state"] = item.state),
              (item["company"] = item.company),
              (item["city"] = item.city),
              (item["country"] = item.country),
              (item["phone"] =
                (item.primaryCountryCode &&
                  `${item.primaryCountryCode} ${item.phoneNumber}`) ||
                (item.phoneNumber && item.phoneNumber)),
              (item["note"] = item.note),
              (item["status"] =
                item.invites && item.invites[0] && item.invites[0].status),
              (item["invite"] =
                item.invites &&
                item.invites[0] &&
                item.invites[0].invititationCode),
              // Individual: item.isTrusted ? "Yes" : "No",
              // audioUrl: item.audioUrl,
              // videoUrl: item.videoUrl,
              // audioFileName: item.audioFileName,
              // videoFileName: item.videoFileName,
              (item["alternatePhone"] =
                (item.alternateCountryCode &&
                  `${item.alternateCountryCode} ${item.alternatePhoneNumber}`) ||
                (item.alternatePhoneNumber && item.alternatePhoneNumber)),
              // secondPasswordGranted: item.secondPasswordGranted ? "Yes" : "No",
              // partOfCoreTeam: item.partOfCoreTeam ? "Yes" : "No",
              // typeOfRelation: item.typeOfRelation,
              (item["idx"] = idx + 1)
            )
          );
          setContactList(res.data[0].contacts);
        }
      }, 1000);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  const showActionModal = () => {
    setActionModal(true);
  };

  const handleActionCancel = () => {
    setActionModal(false);
  };
  const handelCloseModal = () => {
    setShowModal(false);
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const handleShowContactModal = () => {
    setShowConatctsModal(true);
  };

  const handleContactsCancel = () => {
    setShowConatctsModal(false);
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };
  const [pagination, setPagination] = useState({}); // assuming you manage pagination in state
  const handleTableChange = (pagination, filters, sorter) => {
    // Assuming you have a function to fetch data based on pagination, filters, and sorter
    console.log("pagination", pagination);
    setPagination({ ...pagination, current: pagination.current });
  };
  const handleContactsSave = async () => {
    setShowConatctsModal(false);
    const selectedIds = selectedRows.map((row) => row.id);
    console.log("selectedIds", selectedIds);
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.addContactsFromClient({
        contactIds: selectedIds,
      });
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status === 200) {
        console.log("added to contact list");
        swal("Success", apiResponse.message, "success");
        await getContactList();
        const totalContacts = contactList && contactList.length; // Function to get total contacts count
        const totalPages = Math.ceil(totalContacts / 10); // Assuming pageSize is defined
        console.log("totalContacts", totalContacts, totalPages);
        setPagination({ ...pagination, current: totalPages });
      }
      if (
        apiResponse &&
        (apiResponse.status === "ERROR" ||
          apiResponse.status === 400 ||
          apiResponse.status === 500)
      ) {
        swal("Error", apiResponse.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const handleShowGroupModal = () => {
    setShowGroupModal(true);
  };

  const handleGroupCancel = () => {
    setShowGroupModal(false);
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const handleGroupSave = async () => {
    setShowGroupModal(false);
    const selectedIds = selectedRows.map((row) => row.id);
    console.log("selectedIds", selectedIds);
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.addContactsFromGroups({
        groupIds: selectedIds,
      });
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status === 200) {
        console.log("added to contact list");
        await getContactList();
        const totalContacts = contactList && contactList.length; // Function to get total contacts count
        const totalPages = Math.ceil(totalContacts / 10); // Assuming pageSize is defined
        console.log("totalContacts", totalContacts, totalPages);
        setPagination({ ...pagination, current: totalPages });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };
  useEffect(() => {
    getAllData();
    // getContactList();
    // getContactsModule();
    // getGroups();
  }, []);

  const getAllData = async () => {
    await getContactList();
    await getContactsModule();
    await getGroups();
  };

  const getContactsModule = async () => {
    try {
      setLoading(true);
      setClientContacts([]);
      let apiResponse = await DEATH_API.getClientContacts();
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.data) {
        const apiData = apiResponse.data.map((item, index) => {
          let fullName = null;

          if (item.name && item.name.trim() !== "") {
            fullName = item.name.trim();
          } else {
            if (
              item.firstName &&
              item.firstName.trim() !== "" &&
              item.lastName &&
              item.lastName.trim() !== ""
            ) {
              fullName = item.firstName.trim() + " " + item.lastName.trim();
            }
          }

          // Add key with index + 1 value
          const newItem = { ...item, name: fullName };
          return newItem;
        });
        const filteredApiData = apiData.filter(
          (item) => item.name !== null && item.name !== ""
        );
        const filteredApiDataWithKeys = filteredApiData.map((item, index) => ({
          ...item,
          key: index + 1,
        }));
        setClientContacts(filteredApiDataWithKeys);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  //   const findMatchingContacts = () => {
  //     console.log("calling matching function");

  //     if (!contactList || !clientContacts) {
  //         console.log("Contact list or client contacts are empty.");
  //         return;
  //     }

  //     const matchingContacts = contactList.map(apiItem => {
  //         const matchingContact = clientContacts.find(item => item.phoneNumber === apiItem.phone);
  //         return matchingContact ? matchingContact : null; // Return null if not found
  //     }).filter(contact => contact !== null);

  //     console.log("matchingContacts: fetch", matchingContacts);
  //     // Do whatever you need with the matching contacts here

  //     // For example, if you want to set selected row keys with IDs of matching contacts:
  //     const matchingContactIds = matchingContacts.map(contact => contact.id);
  //     setSelectedRowKeys(matchingContactIds);
  // };

  // const findMatchingContacts = () => {
  //       console.log("calling matching function")
  //       const matchingIndexes = contactList && contactList.map(apiItem => {
  //         const index = clientContacts && clientContacts.findIndex(item => item.phoneNumber === apiItem.phone);
  //         return index !== -1 ? index : null; // Return null if not found
  //       }).filter(index => index !== null);
  //       console.log("matchingIndexes: fetch", matchingIndexes);
  //       setSelectedRowKeys(matchingIndexes);

  // };

  const getGroups = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let apiResponse = await DEATH_API.getGroups(ID);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        setAllGroups(apiResponse.groups);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getContactList = async () => {
    try {
      // this.props.handleLoader()
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      // this.setState({
      //   MYID: ID,
      // });
      setMyId(ID);
      let data = await DEATH_API.fetchContactList(ID);
      setContactList([]);
      // console.log("client contacts", data.data[0].clients_contact_lists)
      if (data && data.data) {
        console.log("data in conatct", data.data[0].contacts);
        data.data[0].contacts.map(
          (item, idx) => (
            (item["firstName"] = item.firstName),
            (item["lastName"] = item.lastName),
            (item["email"] = item.email),
            (item["state"] = item.state),
            (item["company"] = item.company),
            (item["city"] = item.city),
            (item["country"] = item.country),
            (item["phone"] = `${item.primaryCountryCode} ${item.phoneNumber}`),
            (item["note"] = item.note),
            (item["status"] =
              item.invites && item.invites[0] && item.invites[0].status),
            (item["invite"] =
              item.invites &&
              item.invites[0] &&
              item.invites[0].invititationCode),
            // Individual: item.isTrusted ? "Yes" : "No",
            // audioUrl: item.audioUrl,
            // videoUrl: item.videoUrl,
            // audioFileName: item.audioFileName,
            // videoFileName: item.videoFileName,
            (item["alternatePhone"] =
              item.alternateCountryCode && item.alternatePhoneNumber
                ? `${item.alternateCountryCode} ${item.alternatePhoneNumber}`
                : ""),
            // secondPasswordGranted: item.secondPasswordGranted ? "Yes" : "No",
            // partOfCoreTeam: item.partOfCoreTeam ? "Yes" : "No",
            // typeOfRelation: item.typeOfRelation,
            (item["idx"] = idx + 1)
          )
        );
        console.log("contactlist data", data.data[0].contacts);
        setContactList(data.data[0].contacts);
      }
      setLoading(false);
      // this.props.handleLoader()
    } catch (error) {
      setLoading(false);
      // this.setState({ isLoading: false })
      console.log(error);
    }
  };

  const downloadContacts = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");

      const res = await DEATH_API.exportPolicySheet("contact", ID);
      setLoading(false);
      console.log("ContactSheet", res.url);
      const customFileName = "Contact List.csv";

      const response = await fetch(res.url);
      const blob = await response.blob();

      saveAs(blob, customFileName);
      if (res.message === "no.record.found") {
        swal("Oops!", res.message, "error");
      } else {
        swal("Success!", res.message, "success");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSelectedRow = (idx, rows, name) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    console.log("rows", rows);
    let selectedRow = rows.filter((row, index) => {
      return row.id == idx;
    });
    // get first and only element from list and store it in update object
    console.log("selectedRow[0]", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const createContact = async (currentFormData) => {
    console.log("addData conatct", addData);
    var arr = [addData];
    try {
      let data = arr;
      console.log("data in conatct list", data);
      // this.props.handleLoader()
      setLoading(true);

      if (Array.isArray(data) && data.length > 0) {
        const allPromisesImage = data.map(async (item) => {
          if (item["Upload Image"]) {
            const formData = new FormData();
            formData.append("uploadImage", item["Upload Image"]);
            console.log("item.uploadImage", item["Upload Image"]);
            const name = item["Upload Image"].name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item["Upload Image"].type,
            });
            const resupload = await axios.put(
              resdata.uploadUrl,
              item["Upload Image"],
              {
                headers: { "Content-type": item["Upload Image"].type },
              }
            );
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item["Upload Image"];
            return { ...item, fileUrl: res, fileName: name };
          }
          return item;
        });

        const allPromises = data.map(async (item) => {
          if (item.Audio) {
            const formData = new FormData();
            formData.append("audio", item.Audio);
            console.log("item.audio", item.Audio);
            const name = item.Audio.name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item.Audio.type,
            });
            const resupload = await axios.put(resdata.uploadUrl, item.Audio, {
              headers: { "Content-type": item.Audio.type },
            });
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item.Audio;
            return { ...item, fileUrlAudio: res, audioName: name };
          }
          return item;
        });
        const allPromises1 = data.map(async (item) => {
          if (item.Video) {
            const formData = new FormData();
            formData.append("video", item.Video);
            console.log("item.video", item.Video);
            const name = item.Video.name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item.Video.type,
            });
            const resupload = await axios.put(resdata.uploadUrl, item.Video, {
              headers: { "Content-type": item.Video.type },
            });
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);

            // const uploaded = await MODULE_API.uploadImage(formData);
            // console.log("file_urlfile_url video", uploaded)
            delete item.Video;
            return { ...item, fileUrlVideo: res, videoName: name };
          }

          return item;
        });
        let resImage = await Promise.all(allPromisesImage);
        let res = await Promise.all(allPromises);
        let res1 = await Promise.all(allPromises1);

        console.log("res>>>> promises audio data", res[0].fileUrlAudio);
        console.log("res>>>> promises video data", res1[0].fileUrlVideo);
        // this.setState({
        //   audio: res[0].fileUrlAudio,
        // });
        // this.setState({
        //   video: res1[0].fileUrlVideo,
        // });
        // this.setState({
        //   audioName: res[0].audioName,
        // });
        // this.setState({
        //   videoName: res1[0].videoName,
        // });
        // console.log("audio state", this.state.audioName)
        // console.log("video state", this.state.videoName)

        // this.props.handleLoader()
        console.log("data contactlist payload...", data);
        const ID = localStorage.getItem("accessId");

        let api_res = await DEATH_API.addContactList(
          {
            contactListForm: data.map((item) => {
              return {
                firstName: item["First Name"],
                lastName: item["Last Name"],
                email: item.Email,
                state: item.State,
                company: item.Company,
                city: item.City,
                country: item.Country,
                phoneNumber: item["Mobile Phone"],
                isTrusted:
                  item.Individual && item.Individual.toLowerCase() === "yes"
                    ? true
                    : false,
                note: item.Notes,
                address: item.Address,
                alternatePhoneNumber: item["Alternate Phone"],
                typeOfRelation: item.TypeOfRelation,
                partOfCoreTeam:
                  item.partOfCoreTeam &&
                  item.partOfCoreTeam.toLowerCase() === "yes"
                    ? true
                    : false,
                // audioUrl: res[0] && res[0].fileUrlAudio, // this.state.audio,
                // videoUrl: res1[0] && res1[0].fileUrlVideo,
                // videoFileName: res1[0] && res1[0].videoName,
                // audioFileName: res[0] && res[0].audioName,
                uploadImage: resImage[0] && resImage[0].fileUrl,
                uploadImageName: resImage[0] && resImage[0].fileName,
                secondPasswordGranted:
                  item.secondPasswordGranted &&
                  item.secondPasswordGranted.toLowerCase() === "yes"
                    ? true
                    : false,
                zipCode: item["Zip Code"] && +item["Zip Code"],
              };
            }),
          },
          ID
        );
        console.log("api_res", api_res);
        // swal("Oops!", api_res.message, "error");
        // if(api_res){

        // }
        // this.props.handleLoader()

        setLoading(false);
        setaddData({});
        await getContactList();
        const totalContacts = contactList && contactList.length; // Function to get total contacts count
        const totalPages = Math.ceil(totalContacts / 10); // Assuming pageSize is defined
        console.log("totalContacts", totalContacts, totalPages);
        setPagination({ ...pagination, current: totalPages });
        // this.props.handleLoader()

        if (api_res.message === "Trustee.Already.exist") {
          swal("Oops!", api_res.message, "error");
        }
        console.log("api_res", api_res);

        if (
          api_res.status === "ERROR" ||
          api_res.status === 400 ||
          api_res.status === 500
        ) {
          swal("Error", api_res.message, "error");
        }
        return api_res;
      }
    } catch (error) {
      setLoading(false);

      // this.props.handleLoader();
      console.log("errrordds in catch block");
      // swal("Oops!", error.message, "error");
      // this.props.handleLoader();
      // throw new Error(error)
    }
  };

  const updateContactRow = async () => {
    console.log("this.state.updateObject contacts", updateObject);

    try {
      // this.props.handleLoader();
      setLoading(true);
      console.log("updated Object", updateObject);
      let obj = {
        ...updateObject,
        firstName: updateObject.firstName && updateObject.firstName,
        lastName: updateObject.lastName,
        email: updateObject.email,
        state: updateObject.state,
        company: updateObject.company,
        city: updateObject.city,
        country: updateObject.country && updateObject.country,
        phoneNumber:
          updateObject["Mobile Phone"] && updateObject["Mobile Phone"],
        note: updateObject.note,
        alternatePhoneNumber:
          updateObject["Alternate Phone"] && updateObject["Alternate Phone"],
        // AlternatePhone: this.state.updateObject.alternatePhoneNumber,
        // audioUrl: updateObject.audioUrl,
        // videoUrl: updateObject.videoUrl,
        // audioFileName: updateObject.audioFileName,
        // videoFileName: updateObject.videoFileName,
        uploadImage: updateObject.uploadImage,
        uploadImageName: updateObject.uploadImageName,
        typeOfRelation: updateObject.typeOfRelation,
        // secondPasswordGranted: updateObject.secondPasswordGranted
        //   ? true
        //   : false,
        // isTrusted: updateObject.Individual ? true : false,
        // partOfCoreTeam: updateObject.partOfCoreTeam ? true : false,
        secondPasswordGranted:
          updateObject.secondPasswordGranted &&
          ((updateObject.secondPasswordGranted == "Yes" && true) ||
            (updateObject.secondPasswordGranted == "No" && false) ||
            updateObject.secondPasswordGranted),
        isTrusted:
          updateObject.isTrusted &&
          ((updateObject.isTrusted == "Yes" && true) ||
            (updateObject.isTrusted == "No" && false) ||
            updateObject.isTrusted),

        partOfCoreTeam:
          updateObject.partOfCoreTeam &&
          ((updateObject.partOfCoreTeam == "Yes" && true) ||
            (updateObject.partOfCoreTeam == "No" && false) ||
            updateObject.partOfCoreTeam),

        zipCode: updateObject.zipCode ? +updateObject.zipCode : null,
      };

      console.log("videoUrl >>>", obj["Video"]);

      if (
        obj["Upload Image"] != "string" &&
        obj["Upload Image"] !== null &&
        typeof obj["Upload Image"] === "object"
      ) {
        const formData = new FormData();
        formData.append("Upload Image", obj["Upload Image"]);

        const name = obj["Upload Image"].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: obj["Upload Image"].type,
        });
        const resupload = await axios.put(
          resdata.uploadUrl,
          obj["Upload Image"],
          {
            headers: { "Content-type": obj["Upload Image"].type },
          }
        );
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss video url", res);
        // const uploaded = await MODULE_API.uploadImage(formData);
        obj.uploadImage = res;
        obj.uploadImageName = name;
      }

      if (
        obj["Video"] != "string" &&
        obj["Video"] !== null &&
        typeof obj["Video"] === "object"
      ) {
        const formData = new FormData();
        formData.append("video", obj["Video"]);

        const name = obj["Video"].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: obj["Video"].type,
        });
        const resupload = await axios.put(resdata.uploadUrl, obj["Video"], {
          headers: { "Content-type": obj["Video"].type },
        });
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss video url", res);
        // const uploaded = await MODULE_API.uploadImage(formData);
        obj.videoUrl = res;
        obj.videoFileName = name;
      }
      if (
        obj["Audio"] != "string" &&
        obj["Audio"] !== null &&
        typeof obj["Audio"] === "object"
      ) {
        console.log("2 else if");
        const formData = new FormData();
        formData.append("audio", obj["Audio"]);
        const name = obj["Audio"].name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: obj["Audio"].type,
        });
        const resupload = await axios.put(resdata.uploadUrl, obj["Audio"], {
          headers: { "Content-type": obj["Audio"].type },
        });
        const res = resdata.uploadUrl.split("?")[0];
        console.log(res);
        console.log("resss audio url", res);
        // const uploaded = await MODULE_API.uploadImage(formData);
        obj.audioUrl = res;
        obj.audioFileName = name;
      } else {
        console.log("in else part");
      }

      console.log("here in api call update", obj);

      // let { contact_list, selectedIndex } = this.state;
      let index = selectedIndex - 1;
      let contact_list = [...contactList]; // important to create a copy, otherwise you'll modify state outside of setState call
      contact_list[index] = obj; // replace current updated object in contact_list based on index
      // this.setState({ contact_list }, () => {
      //   this.props.handleChecklistObject(
      //     this.props.currentForm,
      //     this.state.contact_list
      //   );
      // });
      console.log("obj.id>>>  for update contact ", obj.id, obj);

      const resupdate = await DEATH_API.updateContact(obj.id, obj);
      console.log("resupdate", resupdate);
      if (resupdate.status === 200) {
        swal("Success", resupdate.message, "success");
      } else if (resupdate.status === 400) {
        swal("error", resupdate.message, "error");
      }
      const ID = localStorage.getItem("accessId");
      setLoading(false);

      getContactList();
      console.log("resupdate", resupdate);
      // this.props.handleLoader();
    } catch (error) {
      console.log(error);
      // this.props.handleLoader()
      console.log("error in try catch");
      setLoading(false);

      // this.props.handleLoader();
    }
  };
  const deleteSelectedRow = async (idx) => {
    console.log("index of deleted", idx);

    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteContact(idx);
          const updatedRows = contactList.filter((row, index) => {
            return index != idx - 1;
          });
          // setContactList(updatedRows);
          // that.setState({
          //   contact_list: updatedRows,
          // }, () => {
          //   that.props.handleChecklistObject(that.props.currentForm, that.state.contact_list)
          // });
          // that.props.handleLoader()
          setLoading(false);
          getContactList();
        } catch (error) {
          console.log(error);
          setLoading(false);
          // that.props.handleLoader()
        }
        setTimeout(async () => {
          swal("Deleted!", "Your file has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const handlechange = (e) => {
    console.log("e", e.target);
    // e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handlePhoneChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleSelectChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdateSelectChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    // e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    // console.log("e", e.target);
    // e.preventDefault();
    // const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdatePhoneChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object", updateObject);
    updateContactRow();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createContact();
    handelCloseModal();
  };
  return (
    <div>
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={contactFields}
          modalTitle="Add New Contact"
          handlechange={handlechange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handlePhoneChange={handlePhoneChange}
          handleSelectChange={handleSelectChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={UpdateContactFields}
          modalTitle="Update Contact"
          handlechange={handleUpdatechange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdatePhoneChange={handleUpdatePhoneChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={UpdateContactFields}
          modalTitle="View Contact"
          obj={updateObject}
        />
      )}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Contact List</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              This web-based program does not worry about operating system or
              device types so that you may access anywhere and retrieve contacts
              relevant to the Plan Creator. This is a simple, yet complicated
              functionality of our program as each contact added can be assigned
              a certain permission group or role by the Plan Creator. Each
              contact also can have fields to denote their profession and if
              they are part of a Trusted Team. For example, one group might be
              pickleball friends, another group college buddies, or a contact
              can be listed as a lawyer-cpa-financial expert, and more. By
              creating this contact list feature, Trusted Individuals can
              quickly and easily assess who are those people on the “Trusted
              Team” and what notes did they leave or interactions have they
              posted. Care and collaboration help reduce chaos and lead to
              better outcomes for a difficult situation.
            </Style.ModalDetails>
          </div>
          <div
            style={{
              display: "flex",
              height: "fit-content",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {tooltipModal && (
              <video style={{ width: "25rem" }} controls>
                <source
                  src={
                    "https://assets-planet.s3.amazonaws.com/media/da6a8951-15aa-4be4-8534-0b279d5eb938.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        centered
        visible={actionModal}
        footer={null}
        onCancel={handleActionCancel}>
        <Style.ModalTitle> Contact List</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              Choose Update from the contact menu to make changes or update the
              contact status. Make your choices, and if you upgraded this
              contact to a new Trusted Individual, then they will receive an
              email invitation with a link to accept your invite. Alternatively,
              you can copy the link and paste it into your text or email and
              send it to the person directly.
            </Style.ModalDetails>
          </div>
          <div
            style={{
              display: "flex",
              height: "fit-content",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {actionModal && (
              <video style={{ width: "25rem" }} controls>
                <source
                  src={
                    "https://assets-planet.s3.amazonaws.com/media/da6a8951-15aa-4be4-8534-0b279d5eb938.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            )}
          </div>
        </div>
      </Modal>
      {showConatctsModal && (
        <Modal
          centered
          visible={showConatctsModal}
          footer={null}
          closable={false}
          onCancel={false}>
          <Style.ModalTitle>Add to Contact List</Style.ModalTitle>
          <div style={{}}>
            <div
              style={{
                display: "flex",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <Table
                style={{ width: "100%" }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={clientContacts}
                pagination={{ pageSize: 5 }}
              />
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton onClick={handleContactsCancel}>
              Cancel
            </Style.CancelButton>
            <Style.SaveButton
              style={{
                opacity:
                  selectedRowKeys && selectedRowKeys.length > 0 ? "1" : "0.3",
                cursor:
                  selectedRowKeys && selectedRowKeys.length > 0
                    ? "pointer"
                    : "not-allowed",
                pointerEvents:
                  selectedRowKeys && selectedRowKeys.length > 0 ? "" : "none",
              }}
              id="stop"
              onClick={handleContactsSave}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      {showGroupModal && (
        <Modal
          centered
          visible={showGroupModal}
          footer={null}
          closable={false}
          onCancel={false}>
          <Style.ModalTitle>Add to Contact List</Style.ModalTitle>
          <div style={{}}>
            <div
              style={{
                display: "flex",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <Table
                style={{ width: "100%" }}
                rowSelection={{
                  type: "checkbox",
                  selectedRowKeys: selectedRowKeys,
                  onChange: (selectedRowKeys, selectedRows) => {
                    console.log("selectedRowKeys:", selectedRowKeys);
                    console.log("selectedRows:", selectedRows);

                    setSelectedRowKeys(selectedRowKeys);
                    setSelectedRows(selectedRows);
                  },
                }}
                columns={groupCols}
                dataSource={allGroups}
                pagination={{ pageSize: 5 }}
              />
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton onClick={handleGroupCancel}>
              Cancel
            </Style.CancelButton>
            <Style.SaveButton
              style={{
                opacity:
                  selectedRowKeys && selectedRowKeys.length > 0 ? "1" : "0.3",
                cursor:
                  selectedRowKeys && selectedRowKeys.length > 0
                    ? "pointer"
                    : "not-allowed",
                pointerEvents:
                  selectedRowKeys && selectedRowKeys.length > 0 ? "" : "none",
              }}
              id="stop"
              onClick={handleGroupSave}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        Contact List{" "}
        <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon>
      </Style.MainHeading>

      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Contact List </Style.Title>
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                border: "1px solid #2a3da3",
                borderRadius: "5px",
                marginRight: "1rem",
                height: "2rem",
              }}>
              <img
                style={{ marginTop: "6px", marginLeft: "6px" }}
                width={"20px"}
                height={"20px"}
                src={SearchIcon}
                alt="search"></img>
              <Style.SearchInput
                type="text"
                name="search"
                placeholder="Search"
                onChange={handleSearch}></Style.SearchInput>
            </div>
            <Style.Button
              onClick={() => {
                // setShowModal(true);
                setDropDownContactList(!dropDownContactList);
              }}>
              +
            </Style.Button>
            {dropDownContactList && (
              <>
                <div
                  onClick={() => {
                    setDropDownContactList(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>
                <div
                  class="dropdown"
                  style={{
                    width: "250px",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    zIndex: "9999",
                  }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowModal(true);
                        setDropDownContactList(false);
                      }}>
                      Add Contact
                    </li>
                    <li
                      className="liHover"
                      style={{
                        opacity:
                          clientContacts && clientContacts.length > 0
                            ? "1"
                            : "0.3",
                        cursor:
                          clientContacts && clientContacts.length > 0
                            ? "pointer"
                            : "not-allowed",
                        pointerEvents:
                          clientContacts && clientContacts.length > 0
                            ? ""
                            : "none",
                      }}
                      onClick={() => {
                        // findMatchingContacts();
                        handleShowContactModal();
                        setDropDownContactList(false);
                      }}>
                      Add from Client Contacts
                    </li>
                    <li
                      className="liHover"
                      style={{
                        opacity:
                          allGroups && allGroups.length > 0 ? "1" : "0.3",
                        cursor:
                          allGroups && allGroups.length > 0
                            ? "pointer"
                            : "not-allowed",
                        pointerEvents:
                          allGroups && allGroups.length > 0 ? "" : "none",
                      }}
                      onClick={() => {
                        handleShowGroupModal();
                        setDropDownContactList(false);
                      }}>
                      Add from Groups
                    </li>
                    {contactList && contactList.length > 0 && (
                      <li
                        className="liHover"
                        onClick={() => {
                          downloadContacts();
                          setDropDownContactList(false);
                        }}>
                        Download Contact List
                      </li>
                    )}
                  </ul>
                </div>
              </>
            )}
          </div>
        </Style.HealthCardHeader>
        {/* <List cols={cols} rows={contactList} ></List> */}
        <Table
          columns={cols}
          dataSource={contactList}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
